import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Building2, Stethoscope } from "lucide-react";

const DualHero = () => {
  return (
    <section className="relative bg-background">
      <div className="container max-w-6xl px-5 sm:px-6 lg:px-8 pt-24 pb-16 sm:pt-32 sm:pb-24">
        <div className="max-w-3xl mb-12 sm:mb-16">
          <p className="section-label mb-4 sm:mb-5 text-[10px] sm:text-xs">

            COMPLIANCE INFRASTRUCTURE FOR AUSTRALIAN HEALTH BRANDS & PRACTITIONERS.
          </p>
          <div className="teal-rule mb-6 sm:mb-8" />
          <h1 className="font-display text-[28px] sm:text-[42px] lg:text-5xl text-foreground leading-[1.12] sm:leading-[1.12] mb-5 sm:mb-6 text-left">
            Compliance infrastructure{" "}
            <span className="gold-text">that moves at the speed you do.</span>
          </h1>

          <p className="text-base sm:text-xl text-text-body max-w-2xl text-left leading-relaxed mb-6 sm:mb-8">
            Whether you're a health brand managing digital campaigns or a practitioner publishing clinic content — CompliGUARD reviews, reports, and stores every compliance decision in a defensible audit trail.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 items-start sm:items-center">
            <Button
              asChild
              className="h-11 sm:h-12 px-7 sm:px-8 text-sm sm:text-base font-semibold bg-primary text-primary-foreground hover:bg-accent-hover rounded-full transition-all duration-200 hover:shadow-lg"
            >
              <Link to="/compliance-quiz">Take the 2-min compliance quiz</Link>
            </Button>
            <Link to="/signup" className="text-text-body text-sm hover:text-primary transition-colors">
              Or start your first review →
            </Link>
          </div>
        </div>

        {/* Two-panel cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
          {/* VDS Brands panel */}
          <div className="bg-card p-6 sm:p-8 rounded-sm border border-border card-accent-left-gold shadow-[0_4px_16px_rgba(11,31,53,0.08)] card-hover group">
            <Building2 className="h-8 w-8 text-gold mb-4" />
            <h2 className="text-xl sm:text-2xl font-bold text-foreground mb-2">
              For VDS Brands
            </h2>
            <p className="text-text-body text-sm leading-relaxed mb-6">
              TGA, FSANZ & ACCC compliance for listed medicines, functional foods, and nutraceuticals. Review marketing content across every digital channel.
            </p>
            <Button
              asChild
              className="rounded-full bg-primary text-primary-foreground hover:bg-accent-hover transition-all duration-200 hover:shadow-md"
            >
              <Link to="/vds-brands">Learn about brand compliance →</Link>
            </Button>
          </div>

          {/* Practitioners panel */}
          <div className="bg-card p-6 sm:p-8 rounded-sm border border-border card-accent-left shadow-[0_4px_16px_rgba(11,31,53,0.08)] card-hover group">
            <Stethoscope className="h-8 w-8 text-primary mb-4" />
            <h2 className="text-xl sm:text-2xl font-bold text-foreground mb-2">
              For Practitioners
            </h2>
            <p className="text-text-body text-sm leading-relaxed mb-6">
              AHPRA advertising compliance for healthcare practitioners. Review your website, social posts, and clinic marketing in seconds.
            </p>
            <Button
              asChild
              variant="outline"
              className="rounded-full border-border text-foreground hover:bg-secondary transition-all duration-200"
            >
              <Link to="/practitioners">Learn about practitioner compliance →</Link>
            </Button>
          </div>
        </div>
      </div>

      <div className="absolute right-0 top-1/4 w-px h-1/2 bg-primary/15 hidden lg:block" />
    </section>

  );
};

export default DualHero;
